// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ct[data-v-8f930194] {\n  display: flex;\n  justify-content: flex-start;\n  height: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.ct .li[data-v-8f930194] {\n    width: 4px;\n    height: 20px;\n    background-color: #1890ff;\n}\n.ct .ti[data-v-8f930194] {\n    line-height: 20px;\n    font-size: 18px;\n    font-weight: 500;\n    margin-left: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
